import React from 'react';
export function FeaturesGrid() {
  const features = [{
    title: 'Embudos y Sitios Web',
    desc: 'Diseña páginas de captura y ventas en minutos. Conecta tu dominio y lanza campañas de alta conversión.'
  }, {
    title: 'Email Marketing Pro',
    desc: 'Crea campañas de correo electrónico automatizadas. Mantén a tu audiencia siempre informada.'
  }, {
    title: 'Cursos y Membresías',
    desc: 'Aloja tu contenido educativo y cobra por el acceso. El entorno ideal para tus productos digitales.'
  }, {
    title: 'Workflows Avanzados',
    desc: 'Automatiza tareas repetitivas. Envía respuestas inmediatas y conecta tus apps favoritas.'
  }, {
    title: 'Agenciamiento Online',
    desc: 'Sincroniza tus calendarios de Google o Outlook. Deja que tus prospectos agenden citas directamente.'
  }, {
    title: 'Pagos e Invoicing',
    desc: 'Genera facturas profesionales y cobra a tus clientes de forma segura, directamente desde tu flujo de ventas en el CRM.'
  }, {
    title: 'Bandeja Omnicanal',
    desc: 'Centraliza mensajes de Instagram, Facebook, SMS y WhatsApp. Responde a todos tus clientes desde una sola interfaz.'
  }, {
    title: 'Gestión de Reputación',
    desc: 'Automatiza la solicitud de reseñas en Google Business Profile. Aumenta tu SEO y gana confianza.'
  }, {
    title: 'App Móvil de Gestión',
    desc: 'Lleva tu CRM a todas partes. Recibe notificaciones push de nuevas oportunidades y cierra tratos desde cualquier lugar.'
  }];
  return <section className="py-20 px-4 md:px-8 max-w-7xl mx-auto text-center" data-id="element-36">
      {/* Style 6 + Style 5 — section heading */}
      <h2 className="mb-16" data-id="element-37">
        <span className="text-section-heading" data-id="element-38">¿Qué hace </span>
        <span className="text-section-heading-blue" data-id="element-39">por ti?</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12 text-left" data-id="element-40">
        {features.map((f, i) => <div key={i} className="bg-[#F4F5F7] p-8 rounded-3xl hover:shadow-md transition-shadow" data-id="element-41">
            {/* Style 3 scaled down for grid cards */}
            <h3 className="text-card-heading !text-[20px] !leading-[24px] mb-3" data-id="element-42">
              {f.title}
            </h3>
            <p className="text-body !text-gray-600 !text-[16px] !leading-[24px]" data-id="element-43">
              {f.desc}
            </p>
          </div>)}
      </div>

      <a href="https://api.whatsapp.com/send?phone=525511362283&text=Me interesa prueba gratuita de Valuan CRM…" target="_blank" rel="noopener noreferrer" className="text-btn !text-[#F77730] bg-transparent border-2 border-[#F77730] px-8 py-4 rounded-full hover:bg-[#F77730] hover:!text-white transition-colors !text-[18px] inline-block text-center" data-id="element-44">
        Pruébalo Gratis 7 Días
      </a>
    </section>;
}